<template lang="pug">
.snipe(
  :class="['snipe-'+theme, 'main-container-'+width]"
  :style="{backgroundColor: backgroundColor}"
  )
  .holder(:class="autoSize ? 'main-container' : ''" :style="holderStyle")
    DynamicMedia.logo(v-if="logo" :config="logoConfig" )
    RogueLink.main-img(v-if="mainImage" :to="link" data-track="snipe-link")
      DynamicMedia(:config="mainImageConfig")
    RogueButton.snipe-btn(v-if="buttonText" :link="link" color="red") {{buttonText}}
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { getCloudinaryUrl } from '../../js/helpers'

const props = withDefaults(defineProps<{
  theme?: 'small' | 'large',
  background?: any,
  mainImage?: object,
  width?: string,
  logo?: any,
  buttonText?: string,
  autoSize?: boolean,
  link?: string,
  backgroundColor?: string
}>(), {
  theme           : 'small',
  background      : undefined,
  mainImage       : undefined,
  width           : 'all',
  logo            : undefined,
  buttonText      : undefined,
  autoSize        : true,
  link            : undefined,
  backgroundColor : 'black',
})

const mainImageConfig = computed(() => {
  if (!props.mainImage) {
    return {}
  }

  // Because we have a RogueLink here, we don't want to set another nested RogueLink in the dynamicmedia slot
  return {
    ...props.mainImage,
    link: undefined,
  }
})

const logoConfig = computed(() => {
  if (!props.logo) {
    return undefined
  }

  if (props.logo.alt) {
    return props.logo
  }

  return {
    ...props.logo, alt: props.buttonText,
  }
})

const holderStyle = computed<Record<string, string>>(() => {
  const style: Record<string, string> = {}
  if (props.background) {
    const ratio = props.background.width / props.background.height
    const url = getCloudinaryUrl(props.background.src, 800, Math.round(800 / ratio), '#000')
    style.backgroundImage = `url("${url}")`
  }

  return style
})

</script>
<style lang="scss" scoped>

.snipe-small {
  .holder {
    align-items: center;
    flex-direction: row;
  }
}

.snipe-large {
  .holder {
    align-items: flex-start;
    flex-direction: column;
    margin-right: 0;
    height: 260px;

    @include not-mobile() {
      flex-direction: row;
      align-items: center;
      margin-right: auto;
      height: 240px;
    }

    @include tablet-and-small-desktop() {
      .snipe-btn {
        margin-right: 22px;
      }
    }
  }
}

.holder {
  color: white;
  padding-top: $space-s;
  padding-bottom: $space-s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: no-repeat right center;
  background-size: contain;
}

.main-img {
  display: flex;
  align-items: center;
  margin-right: $space-xxs;

  @include all-desktop() {
    width: 700px;
  }

  @include tablet() {
    width: 450px;
  }

  @include mobile() {
    width: 300px;
  }
}

.logo {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: $space-xxs;
}

.snipe-btn {
  white-space: nowrap;
}

</style>
